module.exports = "varying vec2 vUv;\n\nvoid main() {\n  vUv = uv;\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}\n"